import { service } from "@/api/service ";
import { toast, toastError } from "@/components/custom/Toast";
// import store from "../..";

const state = {
  employeesReview: [],
  employeeReview: [],
  factorReviewers: [],
  availablePeriods: [],
  addStatus: false,
  deleteStatus: false,
  editStatus: false,
  pagination: {},
};
const getters = {
  employeesReviewListGet: (state) => state.employeesReview,
  employeesReviewGet: (state) => state.employeeReview,
  factorReviewersGet: (state) => state.factorReviewers,
  paginationGet: (state) => state.pagination,
  availablePeriods: (state) => state.availablePeriods,
};
const actions = {
  getEmployeesReview({ commit }) {
    service.getFun(`employee-reviews`).then(
      (obj) => {
        var result = obj?.data;
        commit("employeesReviewListSet", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  async getAvailablePeriods({ commit }) {
    const result = await service.getFun(`employee-reviews/periods`);
    if (result) {
      console.log(result, "==");
      commit("setAvailablePeriods", result.data);
    }
  },

  getReviewFactorsForReview({ commit }) {
    service.getFun(`review-factors/reviewer`).then(
      (obj) => {
        var result = obj?.data;
        commit("setReviewFactorForReviewr", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },

  async getEmployeesReviewById({ commit }, payload) {
    const result = await service.getFun(
      `employee-reviews/${payload.employee_id}?year=${payload.year}&period=${payload.period}`
    );
    if (result) {
      commit("employeesReviewById", result.data);
    }
  },
  addEmployeesReview({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `employee-reviews`, null, {
        action: "getEmployeesReview",
      })
      .then(
        (result) => {
          commit("addEmployeesReviewStatus", result?.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
  editEmployeesReview({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `employee-reviews/${payload.id}`,
        null,
        {
          action: "getEmployeesReview",
        }
      )
      .then(
        (result) => {
          if (result) {
            commit("editEmployeesReviewStatus", result.success);
            toast(result.message);
          } else {
            commit("editEmployeesReviewStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  deleteEmployeesReview({ commit }, payload) {
    console.log(payload, "payload");
    service
      .deleteFun(`employee-reviews/${payload?.payload}`, {
        action: "getEmployeesReview",
      })
      .then(
        (result) => {
          commit("deleteEmployeesReviewStatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
};
const mutations = {
  employeesReviewListSet(state, employeesReview) {
    state.employeesReview = employeesReview;
  },
  employeesReviewById(state, employeeReview) {
    state.employeeReview = employeeReview;
  },
  addEmployeesReviewStatus(state, Status) {
    state.addStatus = Status;
  },
  editEmployeesReview(state, Status) {
    state.editStatus = Status;
  },
  deleteEmployeesReviewStatus(state, Status) {
    state.deleteStatus = Status;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
  setReviewFactorForReviewr(state, reviewFactorsForReviewers) {
    state.factorReviewers = reviewFactorsForReviewers;
  },
  setAvailablePeriods(state, availablePeriods) {
    state.availablePeriods = availablePeriods;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
